import { IAward } from '../../../interfaces';
import privateHttpClient from '../privateHttpClient';
import AwardAutoMapper from '../mappers/AwardAutoMapper';
import { urlHttpGov } from '../../urls';

export interface IAwardsOrderObject {
    id: number,
    order: number,
}

class AwardsAutoService {
    private baseURL: string = `${urlHttpGov}/panel/award-auto`;

    async listAwards(signal: AbortSignal) {

        const { data } = await privateHttpClient.get(this.baseURL, { signal });

        return data.map((award: any) => AwardAutoMapper.toDomain(award));
    }

    async createAward(award: FormData) {
        const { data } = await privateHttpClient.post(this.baseURL, award, { headers: { "content-type": 'multipart/form-data' } });

        const domainAward = AwardAutoMapper.toDomain(data);

        return domainAward;
    }

    async getAwardById(id: number, signal: AbortSignal) {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return AwardAutoMapper.toDomain(data);
    }

    async updateAward(id: number, award: FormData) {
        const { data } = await privateHttpClient.patch(`${this.baseURL}/${id}`, award, { headers: { "content-type": "multipart/form-data" } });

        return AwardAutoMapper.toDomain(data);
    }

    deleteAward(id: number) {
        return privateHttpClient.delete(`${this.baseURL}/${id}`);
    }

    async listAwardsByGiveawayId(giveawayId: number, signal?: AbortSignal): Promise<Array<IAward>> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/raffle/${giveawayId}`, { signal });

        return data.map((award: any) => AwardAutoMapper.toDomain(award));
    }

    updateAwardsOrder(award_order: Array<IAwardsOrderObject>) {
        return privateHttpClient.put(`${this.baseURL}/ordering`, { award_order });
    }

    async validateAward(id: number, isValid: boolean, observation: string | undefined): Promise<IAward> {
        const { data } = await privateHttpClient.put(`${this.baseURL}/status/${id}`, {
            is_approve: isValid,
            observation,
        });

        return AwardAutoMapper.toDomain(data);
    }

    async getAwardWinnersByGiveawayIdAndAttemptNumber({ giveawayAutoId, attemptNumber, signal }: { giveawayAutoId: number, attemptNumber: number, signal?: AbortSignal }): Promise<IAward[]> {

        const { data } = await privateHttpClient.get(`${this.baseURL}/winners/raffle/${giveawayAutoId}/attempt/${attemptNumber}`, { signal });

        return data.map((award: any) => AwardAutoMapper.toDomain(award));
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AwardsAutoService();
